import React from 'react';
import { connect } from 'react-redux';
import { closeSnackbar } from 'redux/snackbar/actions';
import Snackbar from '@material-ui/core/Snackbar';

const CopiedSnackbar = ({
  open,
  message,
  onClose,
}) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      message={message}
    />
  );
};

const mapStateToProps = state => ({
  open: state.snackbar.open,
  message: state.snackbar.message,
});

export default connect(mapStateToProps, { onClose: closeSnackbar })(CopiedSnackbar);



// WEBPACK FOOTER //
// ./src/components/IterioApp/components/AppSnackbar/AppSnackbar.jsx